<template>
	<div class="sideways-content-fold" v-if="activePanel">
		<div class="portlet light bordered" v-if="process === 'form' || process === 'form_advanced'">
			<div class="portlet-title">
				<div class="caption">
					Create A Role
				</div>
			</div>
			<div class="portlet-body">
				<form role="form" novalidate :class="{'disabled': process === 'form_advanced'}">
					<div class="alert alert-danger" v-if="errorMessage.length">
					    <button class="close" data-close="alert" @click="clearError()"></button>
                        <span>{{ errorMessage }}</span>
					</div>
					<div class="form-body invite-user-form">
						<div class="form-group form-md-line-input form-md-floating-label">
                            <input type="text" class="form-control input-sm" :class="{'edited': newRole.name.length}" id="create_role_name" v-model="newRole.name" :disabled="process === 'form_advanced'">
                            <label for="create_role_name">Role Name</label>
                        </div>
                        <div class="form-md-checkboxes margin-bottom-20">
                        	<div class="md-checkbox-inline">
                        		<div class="md-checkbox">
                        			<input type="checkbox" id="checkbox-assign-approval" class="md-check" v-model="newRole.approval_permission" :disabled="process === 'form_advanced'">
                        			<label for="checkbox-assign-approval">
                        				<span></span>
                        				<span class="check"></span>
                        				<span class="box"></span>
                        				Assign this role <b>Approval Permissions.</b>
                        			</label>
                        		</div>
                        	</div>
                        </div>
					</div>
					<div class="form-actions noborder invite-user-actions">
						<button type="button" class="btn btn-default exit-invitation-setup" @click="closePanel()"> Return To Roles Dashboard</button>
						<button type="button" class="btn blue" @click="advanceForm()" v-if="process === 'form'" :disabled="!newRole.name.length">Continue <i class="fa fa-arrow-circle-right"></i></button>
					</div>
				</form>
				<transition name="fade">
					<form class="border-top" role="form" @submit.prevent="createRole($event)" novalidate v-if="process === 'form_advanced'">
						<div class="margin-top-20 portlet-title-alternate">Assign App Privileges</div>
						<div class="margin-top-20 row search-content-4" v-if="apps.length">
		      				<div class="search-table table-responsive">
		      					<table class="table table-striped table-condensed">
		      						<thead>
		      							<tr>
		      								<th></th>
		      								<th><a class="no-click font-grey-mint">No Access</a></th>
		      								<th><a class="no-click font-grey-mint">View</a></th>
		      								<th><a class="no-click font-grey-mint">View &amp; Modify</a></th>
		      							</tr>
		      						</thead>
		      						<tbody>
		      							<tr v-for="app in apps">
		      								<td><h4>{{ app.app_name }}</h4></td>
		      								<td>
		      									<div class="md-radio">
		      										<input type="radio" :id="`app_privileges_no_access_${app.app_id}`" :name="`app_privileges_${app.app_id}`" class="md-radiobtn" v-model="app.access_level" value="none">
		      										<label :for="`app_privileges_no_access_${app.app_id}`">
		      											<span></span>
		      											<span class="check"></span>
		      											<span class="box"></span>
		      										</label>
		      									</div>
		      								</td>
		      								<td>
		      									<div class="md-radio">
		      										<input type="radio" :id="`app_privileges_view_${app.app_id}`" :name="`app_privileges_${app.app_id}`" class="md-radiobtn" v-model="app.access_level" value="view">
		      										<label :for="`app_privileges_view_${app.app_id}`">
		      											<span></span>
		      											<span class="check"></span>
		      											<span class="box"></span>
		      										</label>
		      									</div>
		      								</td>
		      								<td>
		      									<div class="md-radio">
		      										<input type="radio" :id="`app_privileges_modify_${app.app_id}`" :name="`app_privileges_${app.app_id}`" class="md-radiobtn" v-model="app.access_level" value="modify">
		      										<label :for="`app_privileges_modify_${app.app_id}`">
		      											<span></span>
		      											<span class="check"></span>
		      											<span class="box"></span>
		      										</label>
		      									</div>
		      								</td>
		      							</tr>
		      						</tbody>
		      					</table>
		      				</div>
		      			</div>
		      			<div v-else>
							<div class="alert alert-danger">
			                    <span>No apps found for your business.</span>
							</div>
		      			</div>
		      			<button type="button" class="btn btn-default exit-invitation-setup" @click="closePanel()"> Return To Roles Dashboard</button>
						<button type="submit" class="btn blue">Submit</button>
					</form>
				</transition>
			</div>
		</div>
		<next-actions v-else :actionsList="createRoleNextActions" @runFunction="runFunction"></next-actions>
	</div>
</template>
<script>
import $ from 'jquery'
import NextActions from '../../../modules/NextActions'
import GlobalFunctions from '../../../../global'
import Role from '../../../../controllers/Roles'
import Business from '../../../../controllers/Business'

/**
 * Create Role module is a page for creating new roles in a business.
 * @class CreateRole
 * @extends Roles
 * @prop {number} businessId - Used to pass the business id of the business the role is being created for.
 * @prop {string} baseRoute - The route of the component that this is being called from.
 * @prop {string} baseRouteName - The name of the route of the component that this is being called from.
 * @since 0.0.6
 */

export default {
	name: 'create-role',
	props: {
		businessId: {
			type: Number,
			required: true
		},
		baseRoute: {
			type: String,
			required: true
		},
		baseRouteName: {
			type: String,
			required: true
		}
	},
	data () {
		return {
			process: 'form',
			activePanel: false,
			errorMessage: '',
			apps: [],
			newRole: {
				name: '',
				approval_permission: false,
				app_permissions: []
			},
			createRoleNextActions: [{title: 'Create Another Role', icon_class: 'fa fa-user', click_event: 'resetProcess'}, {title: 'Return to Roles Dashboard', icon_class: 'fa fa-arrow-circle-left', click_event: 'closePanel'}]
		}
	},
	/**
	 * Run on created to determine if this should be the active panel or not.
	 * @function
	 * @return {undefined}
	 * @memberof CreateRole
	 * @version 0.0.8
	 */
	created () {
		if (this.$route.name === this.baseRouteName + ' - Create Role') {
			this.activePanel = true
			if (!this.apps.length) {
				this.getBusinessDetails()
			} else {
				this.resetApps()
			}
		}
	},
	methods: {
		/**
		 * To clear the current error.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateRole
		 * @version 0.0.6
		 */
		clearError () {
			this.errorMessage = ''
		},
		/**
		 * To set all app access levels to 'none'
		 * @function
		 * @returns {undefined}
		 * @memberof CreateRole
		 * @version 0.0.6
		 */
		resetApps () {
			this.apps.forEach((app, index, apps) => {
				apps[index].access_level = 'none'
			})
		},
		/**
		 * To pull in details about the current business, mainly for getting list of available apps.
		 * @function
		 * @return {object} A promise that will either return an error message or display the success screen.
		 * @memberof CreateRole
		 * @version 0.0.8
		 */
		getBusinessDetails () {
			let _this = this

			return Business.getBusinessDetails(this.businessId).then(response => {
				_this.apps = response.payload.apps

				_this.apps.forEach((app, index, apps) => {
					apps[index].access_level = 'none'
				})
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {
					case 'business_not_found':
						// Do something
						break

					default:
						// No default
					}
				}
			}))
		},
		/**
		 * To check if the name is valid before submitting to the backend.
		 * @function
		 * @return {object} A promise that will validate the input form
		 * @memberof CreateRole
		 * @version 0.0.6
		 */
		validateRoleData () {
			let _this = this
			return new Promise((resolve, reject) => {
				if (!_this.newRole.name.length) {
					reject('Role name cannot be blank')
				}
				resolve()
			})
		},
		/**
		 * To send the details of the new role to the backend.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @param {boolean} bypassConflict - Whether or not we should bypass any conflicts.
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof CreateRole
		 * @version 0.0.8
		 */
		createRole (event, bypassConflict) {
			let disabledButton = GlobalFunctions.disableButton(event)
			let _this = this

			this.newRole.app_permissions = this.apps

			return _this.validateRoleData()
			.then(response => {
				_this.clearError()
				Role.createRole(_this.businessId, _this.newRole, bypassConflict).then(response => {
					_this.clearForm()
					_this.process = 'next_actions'
					disabledButton.complete()
				}).catch(_this.$root.errorWrapper(e => {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
						case 'already_exists':
							_this.errorMessage = 'A role with this name already exists. Please choose a different name.'
							_this.process = 'form'
							break

						case 'role_conflict':
							_this.$swal({
								title: 'Are you sure?',
								html: 'There is already a role that has these permissions. Do you still want to create this role?',
								type: 'warning',
								showCancelButton: true,
								confirmButtonText: 'Create Role',
								confirmButtonColor: '#d9534f',
								cancelButtonText: 'Cancel',
								allowOutsideClick: false,
								allowEscapeKey: false,
								allowEnterKey: false,
								showLoaderOnConfirm: true
							}).then(() => {
								_this.createRole(false, true)
							}, dismiss => {
								// Do nothing on dismiss
							})
							break

						default:
							// No default
						}
					}
					disabledButton.cancel()
				}))
			}).catch(reason => {
				// If validation fails then display the error message
				_this.errorMessage = reason
				disabledButton.cancel()
			})
		},
		/**
		 * To clear the object 'newRole'.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateRole
		 * @version 0.0.6
		 */
		clearForm () {
			this.newRole = {
				name: '',
				approval_permission: false,
				app_permissions: []
			}
			this.resetApps()
			$('.invite-user-form').find('input, select').removeClass('edited')
		},
		/**
		 * To run the function passed in.
		 * @function
		 * @param {string} functionName - The function that is to be run
		 * @param {array} params - The list of parameters being passed into the function
		 * @returns {undefined}
		 * @memberof CreateRole
		 * @version 0.0.6
		 */
		runFunction (functionName, params) {
			if (!params) {
				this[functionName]()
			} else {
				this[functionName](params[0])
			}
		},
		/**
		 * To move to the advanced portion of the form.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateRole
		 * @version 0.0.6
		 */
		advanceForm () {
			this.process = 'form_advanced'
		},
		/**
		 * To reset the panel to display the form.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateRole
		 * @version 0.0.6
		 */
		resetProcess () {
			this.process = 'form'
		},
		/**
		 * To close the create role panel by redirecting to the dashboard
		 * @function
		 * @returns {undefined}
		 * @memberof CreateRole
		 * @version 0.0.8
		 */
		closePanel () {
			this.process = 'form'
			this.$router.push(this.baseRoute)
		},
		/**
		 * To redirect to the approval permissions panel
		 * @function
		 * @returns {undefined}
		 * @memberof CreateRole
		 * @version 0.0.8
		 */
		redirectToAppAccess () {
			this.process = 'form'
			this.$router.push(this.baseRoute + '/app_access')
		}
	},
	watch: {
		/**
		 * To `watch` the $route in order to determine if this panel should be showing or not
		 * @function
		 * @returns {undefined}
		 * @memberof CreateRole
		 * @version 0.0.8
		 */
		'$route' () {
			if (this.$route.name === this.baseRouteName + ' - Create Role') {
				this.activePanel = true
				this.process = 'form'
				this.clearError()
				this.clearForm()
				if (!this.apps.length) {
					this.getBusinessDetails()
				} else {
					this.resetApps()
				}
			} else {
				this.activePanel = false
			}
		}
	},
	components: {
		NextActions
	}
}
</script>


// WEBPACK FOOTER //
// CreateRole.vue?676bd98e